import { DashboardFilter } from '../shared/models/dashboard-filter';
import { Component, Input, OnChanges, SimpleChange, OnDestroy } from '@angular/core';
import { DashboardService } from '../shared/services';
import { Subscription } from 'rxjs/Subscription';
import { EmployeeSales  } from '../shared/models';

@Component({
    selector: 'dashboard-employees',
    template: require('./dashboard-employees.component.pug')
})
export class DashboardEmployeesComponent implements OnChanges, OnDestroy {
    @Input() dashboardFilter: DashboardFilter;

    employeeSales: EmployeeSales[];

    private _employeeSalesSubscription: Subscription;

    constructor(private _dashboardService: DashboardService) { }

    ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
        let dashboardFilter = changes['dashboardFilter'].currentValue;
        if (dashboardFilter) {
            this._employeeSalesSubscription = this._dashboardService.getEmployeeSales(dashboardFilter)
                .subscribe(sales => this.employeeSales = sales);
        }
    }

    ngOnDestroy() {
        //this._employeeSalesSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/dashboard/employees/dashboard-employees.component.ts